import React, { FC } from 'react';
import iconFuelPump from '../../assets/iconFuelPump.svg';
import iconProTransport from '../../assets/iconProTransport.svg';
import iconFactoring from '../../assets/iconFactoring.svg';
import iconFreight from '../../assets/iconFreight.svg';
import { RepCardFilter } from './RepCardFilter';
import { RepData } from '../..';
import styles from './repStyles.scss';
import { CompanyPermissions } from '../../../services/freightPermissionService';

interface ContactUsRepsProps {
  repsData: RepData[];
  freightPermissionsFF: boolean;

  carrierPermissionsData?: CompanyPermissions;
}

export const ContactUsReps: FC<ContactUsRepsProps> = ({ repsData, freightPermissionsFF, carrierPermissionsData }) => {
  const [fuelData, factoringData, proTransportData] = repsData;

  const freightData: Partial<RepData> | undefined =
    carrierPermissionsData && carrierPermissionsData?.companyPermissions.length > 0
      ? {
          email: 'support@rtspro.com',
          phone: '8888747053',
          product: 'Ryan Transportation',
          name: 'Support',
        }
      : undefined;

  return (
    <div className={styles.repCardsContainer}>
      <RepCardFilter icon={iconFactoring} serviceName="Factoring" target="factoring" data={factoringData} />
      <div className={styles.lineBorder} />
      <RepCardFilter icon={iconFuelPump} serviceName="Fuel" target="fuel" data={fuelData} />
      <div className={styles.lineBorder} />
      {freightPermissionsFF && (
        <>
          <RepCardFilter icon={iconFreight} serviceName="Freight" target="freight" data={freightData as RepData} />
          <div className={styles.lineBorder} />
        </>
      )}

      <RepCardFilter icon={iconProTransport} serviceName="ProTransport" target="loads" data={proTransportData} />
    </div>
  );
};
